import APIClient, { failSafe, makeCancellableAPIRequest } from "./index";

const ProjectAPI = {
    getAll(){
        return failSafe(
            APIClient.get("/user/project")
        );
    },
    get(id){
        return failSafe(
            APIClient.get(`/user/project/${id}`)
        );
    },
    save(data){
        return failSafe(
            APIClient.post(`/user/project`, {
                ...data
            })
        );
    },
    update(data){
        return failSafe(
            APIClient.put(`/user/project`, {
                ...data
            })
        );
    },
    delete(id){
        return failSafe(
            APIClient.delete(`/user/project/${id}`)
        )
    },
    validate(params = {}, showDefaultMessage = false){
        return makeCancellableAPIRequest(
            "GET",
            `/user/project/validate`,
            {
                params
            },
            showDefaultMessage
        )
    },
    v2:{
        getAll(params = {}){
            return makeCancellableAPIRequest(
                "GET",
                `/user/project`,
                {
                    params
                }
            )
        }
    },
    getReport(id) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/project/${id}/report`
        )
    },
    uploadFile(projectId, fileName){
        return failSafe(
            APIClient.get(`/user/project/upload/${projectId}/${fileName}`)
        ); 
    },
    deleteFile(projectId, fileName){
        return failSafe(
            APIClient.delete(`/user/project/delete/document/${projectId}/${fileName}`),
            false
        ); 
    },
    createClone(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/project/clone`,
            {
                data
            }
        )
    }
}

export default ProjectAPI;